/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Gateway_Sub_Spend_ResetsInputs */



/**
* | output |
* | --- |
* | "Resets on {date}" |
*
* @param {Gateway_Sub_Spend_ResetsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_sub_spend_resets = /** @type {((inputs: Gateway_Sub_Spend_ResetsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Sub_Spend_ResetsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Zurücksetzung am ${i?.date}`)
	return /** @type {LocalizedString} */ (`Resets on ${i?.date}`)
});